// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"Settings__srOnly--3ZXLi","hiddenInput":"Settings__hiddenInput--1cbJv","main":"Settings__main--34_JC"};